import React, { useEffect, useState } from 'react'
import { Api, IApiSourceResponse } from '@apis/client';
import axios, { AxiosResponse } from 'axios';
import { platform } from '../../../../../helpers/Constants';
import './index.module.less'
import FridayService from '@services/friday';


interface IAppInfo {
  softPublishtime: string;
  softVersion: string;
  downloadUrl: string;
}
export default () => {
  const [showExternalTips, setShowExternalTips] = useState(false)

  const [appInfo, setAppInfo] = useState<IAppInfo>()

  const onClickDownload = () => {
    FridayService.addEvent('download_button_click');
    if(platform.wechat && platform.android) {
      setShowExternalTips(true)
    }
  }

  useEffect(() => {
    FridayService.addEvent('download_self_show');
    axios.post<IApiSourceResponse[Api.GetAppSoftInfo], AxiosResponse<IApiSourceResponse[Api.GetAppSoftInfo]>>(`${window.PUBLIC_URL}/api.json?action=${Api.GetAppSoftInfo}`, {}, {
      headers: { 'Content-Type': 'application/json' },
    }).then((res) => {
      const date = new Date(res.data.data.softPublishtime)
      let year = `${date.getFullYear()}`
      let month = `${date.getMonth() + 1}`
      let day = `${date.getDay()}`
      month = +month < 10 ? `0${month}` : month
      day = +day < 10 ? `0${day}` : day
      setAppInfo({
        softPublishtime: `${year}/${month}/${day}`,
        softVersion: res.data.data.softVersion,
        downloadUrl: platform.ios
          ? 'itms-apps://itunes.apple.com/app/id1580341926'
          : res.data.data.downloadUrl
      })
    })
  }, [])

  return <>
    <div styleName="btn-box">
      <a href={ appInfo?.downloadUrl } styleName="btn-primary" onClick={onClickDownload}>立即下载</a>
    </div>
    <div styleName="info">开发者：广州视睿电子科技有限公司
    | <a href="/modules/cube-app-permissions">应用权限</a> | <a href="/modules/yunban-app-privacy-agreement">隐私政策</a>
    <br />希沃魔方 | 应用版本 {appInfo?.softVersion} | 更新时间 {appInfo?.softPublishtime}</div>
    { showExternalTips ? <div styleName="external-tips" /> : null }
  </>
}